import React, { useEffect } from "react";
import "./component/css/App.css";
import UserRole from "./component/UserRole";

function getFaviconEl() {
  return document.getElementById("favicon");
}
function geticEl() {
  return document.getElementById("icon");
}
function geticonEl() {
  return document.getElementById("ic");
}

const App = () => {
  // useEffect(() => {
  //   const favicon = getFaviconEl();
  //   const icon = geticonEl();
  //   const ic = geticEl();
  //   favicon.href = "https://www.google.com/favicon.ico";
  //   // icon.href = "https://www.google.com/favicon.ico";
  //   ic.href = "https://www.google.com/favicon.ico";
  // }, []);

  return (
    <div className="rtl">
      <div className="mar">
        <UserRole />
      </div>
    </div>
  );
};

export default App;
